var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.is_loaded
      ? _c(
          "div",
          {
            staticStyle: {
              "max-width": "1320px",
              margin: "auto",
              padding: "10px 20px 0",
            },
          },
          [
            _c("div", { staticClass: "pta-meeting-head" }, [
              _c("h2", [_vm._v("Meeting Minutes")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.transcript.title))]),
              _vm._v(" "),
              _c("ul", { staticClass: "mm-links" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "mm-link-pdf",
                      attrs: { href: "/mm/" + _vm.transcript.alias + "/pdf" },
                    },
                    [_vm._v("PDF")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "mm-link-word",
                      attrs: { href: "/mm/" + _vm.transcript.alias + "/doc" },
                    },
                    [_vm._v("Word")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-meeting-left" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#E9F8FC",
                    border: "1px solid #34A7C2",
                    padding: "30px",
                    "margin-bottom": "30px",
                    "border-radius": "10px",
                    "font-size": "16px",
                    "line-height": "22px",
                    color: "#1C2136",
                  },
                },
                [
                  _vm._v(
                    "\n        Minutes of the meeting held on " +
                      _vm._s(_vm._f("momentDateTime")(_vm.transcript.held_at)) +
                      "."
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v("\n        In attendance:\n        "),
                  _vm.transcript.speakers
                    ? _c(
                        "span",
                        { staticClass: "pta-transcript-participant" },
                        [_vm._v(_vm._s(_vm.transcript.speakers))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.transcript.participants, function (participant) {
                    return !_vm.transcript.speakers
                      ? _c(
                          "span",
                          { staticClass: "pta-transcript-participant" },
                          [_vm._v(_vm._s(participant.name))]
                        )
                      : _vm._e()
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-meeting-right" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#ffffff",
                    padding: "30px",
                    "margin-bottom": "30px",
                    "border-radius": "10px",
                  },
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        "font-weight": "600",
                        "margin-bottom": "30px",
                      },
                    },
                    [_vm._v("Topics Discussed")]
                  ),
                  _vm._v(" "),
                  _vm.transcript.topics && _vm.transcript.topics.length
                    ? _c(
                        "div",
                        { staticClass: "pta-meeting-topics" },
                        _vm._l(_vm.topics_array, function (topic, index) {
                          return _vm.topics_array_values[index]["number"]
                            ? _c("div", [
                                _c(
                                  "h5",
                                  {
                                    staticStyle: {
                                      "font-size": "19px",
                                      "line-height": "24px",
                                      "font-weight": "500",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#029165",
                                          display: "inline-block",
                                          "margin-right": "10px",
                                          "font-size": "13px",
                                          background: "#9DF6E4",
                                          "line-height": "14px",
                                          padding: "5px 10px",
                                          position: "relative",
                                          top: "-2px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.topics_array_values[index][
                                              "number"
                                            ]
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        _vm.topics_array_values[index]["title"]
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.topics_array_values[index]["summary"]
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#ffffff",
                    padding: "30px",
                    "margin-bottom": "30px",
                    "border-radius": "10px",
                  },
                },
                [
                  _c("h3", { staticStyle: { "font-weight": "600" } }, [
                    _vm._v("General Summary of the Meeting"),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { "font-size": "16px", "line-height": "22px" },
                    domProps: { innerHTML: _vm._s(_vm.typeValue) },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#ffffff",
                    padding: "30px",
                    "margin-bottom": "30px",
                    "border-radius": "10px",
                  },
                },
                [
                  _c("h3", { staticStyle: { "font-weight": "600" } }, [
                    _vm._v("Content"),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { "font-size": "16px", "line-height": "22px" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.transcript.content.replace(
                          /(?:\r\n|\r|\n)/g,
                          "<br>"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "left" } }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { padding: "20px" } }, [
      _c("a", { attrs: { href: "/", title: "Home" } }, [
        _c("img", {
          staticClass: "header-logo",
          attrs: {
            src: "/images/logo.svg",
            width: "246",
            height: "42",
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          background: "#ffffff",
          padding: "30px",
          "margin-bottom": "30px",
          "border-radius": "10px",
        },
      },
      [
        _c(
          "h3",
          { staticStyle: { "font-weight": "600", "margin-bottom": "30px" } },
          [_vm._v("Suggested Meeting Agenda")]
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "pta-meeting-agenda" }, [
          _c("li", [_c("i", [_vm._v("1")]), _vm._v("Introduction - Investor")]),
          _vm._v(" "),
          _c("li", [_c("i", [_vm._v("2")]), _vm._v("Introduction - Sponsor")]),
          _vm._v(" "),
          _c("li", [_c("i", [_vm._v("3")]), _vm._v("Presentation - Sponsor")]),
          _vm._v(" "),
          _c("li", [_c("i", [_vm._v("4")]), _vm._v("Q&A")]),
          _vm._v(" "),
          _c("li", [
            _c("i", [_vm._v("5")]),
            _vm._v(
              "Discussion regarding next steps and additional documents to be exchanged."
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }